import {
  Button,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { Link } from '../../components/global/Link';
import { Frame } from '../../components/layouts/Frame';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { UserCreditData } from '../../types';
import { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useAPI } from '../../hooks/useAPI';

export const BuyCreditComplete = () => {
  const { isAuthenticated } = useAuth();
  const { fetchData } = useAPI();
  const [searchParams] = useSearchParams();
  const params = useParams();
  const navigate = useNavigate();
  const credit_id = params.credit_id;
  const billing_name = searchParams.get('billing_name');
  const company_name = searchParams.get('company_name');
  const billing_email = searchParams.get('billing_email');
  const billing_address = searchParams.get('billing_address');
  const billing_city = searchParams.get('billing_city');
  const billing_county = searchParams.get('billing_county');
  const billing_postcode = searchParams.get('billing_postcode');
  const billing_country = searchParams.get('billing_country');
  const payment_intent = searchParams.get('payment_intent');
  const payment_intent_client_secret = searchParams.get(
    'payment_intent_client_secret',
  );

  useEffect(() => {
    if (isAuthenticated) {
      fetchData(
        `/credits/buy`,
        {
          credit_id,
          payment_intent,
          payment_intent_client_secret,
          billing_name,
          company_name,
          billing_email,
          billing_address,
          billing_city,
          billing_county,
          billing_postcode,
          billing_country,
        },
        'POST',
      ).then(({ errors, data }) => {
        if (errors) {
          alert(`failed on saving order: ${JSON.stringify(errors)}`);
          console.error('failed on saving order', errors);
          return false;
        } else {
          navigate(`/buy-credit/thank-you?user-credit-id=${data.id}`);
        }
      });
    }
  }, [credit_id, isAuthenticated]);

  return (
    <Frame title="Buy Credits">
      <Stack padding={8} textAlign="center">
        <Typography
          variant="h5"
          fontWeight="600"
          color="#040505"
          lineHeight="200%">
          Completing purchase...
        </Typography>
      </Stack>
    </Frame>
  );
};
